import { defineMessages } from 'react-intl';

const parkingStatusMessages = defineMessages({
    title: {
        id: 'parking-status-title',
        defaultMessage: 'Parking Status',
    },
    devices: {
        id: 'devices',
        defaultMessage: 'Devices',
    },
    devicesSubtitle: {
        id: 'devices-subtitle',
        defaultMessage:
            'Devices are all the hardware available in the parking. You can track their status and manage them while also being able to see a detailed history of their service and life.',
    },
    devicesNoIssues: {
        id: 'devices-no-issues',
        defaultMessage: 'No issues',
    },
    devicesTurnedOff: {
        id: 'devices-turned-off',
        defaultMessage: 'Turned off',
    },
});

export { parkingStatusMessages };
